let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jhykh")).then(() => parcelRequire('5FrU9'));